import { Modal } from "@monolith-forensics/monolith-ui";
import { MergeInquiryForm, MergeInquiryFormData } from "../Forms";

interface MergeInquiryModalProps {
  show: boolean;
  inquiry: { inquiry_id: number; inquiry_case_num: string };
  defaultFormData?: Partial<MergeInquiryFormData>;
  onClose: () => void;
  onSubmit: () => void;
  onCancel?: () => void;
}

export const MergeInquiryModal: React.FC<MergeInquiryModalProps> = ({
  show,
  inquiry,
  defaultFormData,
  onClose,
  onSubmit,
  onCancel,
}) => {
  const handleSubmit = () => {
    onSubmit?.();
    onClose();
  };

  const handleCancel = () => {
    onCancel?.();
    onClose();
  };

  return (
    <Modal open={show} onClose={onClose}>
      <MergeInquiryForm
        inquiry={inquiry}
        onSubmit={handleSubmit}
        onCancel={handleCancel}
        defaultFormData={defaultFormData}
      />
    </Modal>
  );
};
